import { DialogContentText } from "@mui/material";
import { ConfirmationContent } from "Common/Components";
import { CONFIRMATION_TYPES, UI_ELEMENTS } from "Common/Constants";
import { IConfirmationContent, IConversationTitle } from "Common/Interfaces";

interface IGetConfirmationContent {
  activeElement: UI_ELEMENTS | null;
  dataRow: IConversationTitle | null;
  isLoadingDeleteChat: boolean;
}

export const getConfirmationContent = (props: IGetConfirmationContent): IConfirmationContent | null => {
  const { activeElement, dataRow, isLoadingDeleteChat } = props;
  switch (activeElement) {
    case UI_ELEMENTS.DELETE_CONFIRMATION:
      return {
        title: "Delete Confirmation !",
        message: <ConfirmationContent title="Are you sure you want to delete" value={dataRow?.title} />,
        event: CONFIRMATION_TYPES.DELETE,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        isLoadingConfirmButton: isLoadingDeleteChat,
        disabledCancelButton: isLoadingDeleteChat,
      };
    case UI_ELEMENTS.CANCEL_CONFIRMATION:
      return {
        title: "Unsaved Changes",
        message: (
          <DialogContentText
            sx={{
              color: "text.primary",
              pb: 1,
              minWidth: "400px",
              textAlign: "center",
            }}
          >
            Are you sure you want to cancel your changes ?
          </DialogContentText>
        ),
        event: CONFIRMATION_TYPES.CANCEL,
        confirmButtonText: "Cancel",
        cancelButtonText: "Keep",
      };
    default:
      return null;
  }
};
